export default "__VITE_ASSET__ONNZxphX__"